module.exports = __webpack_public_path__ + "img/triangle-5.42c26487.gif";